import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import RequireAdmin from "@/components/RequireAdmin";
import Home from "@/pages/Home";
import News from "@/pages/News";
import NewsArticle from "@/pages/NewsArticle";
import Winners from "@/pages/Winners";
import Polls from "@/pages/Polls";
import Live from "@/pages/Live";
import Season from "@/pages/Season";
import Teams from "@/pages/Teams";
import TeamDetail from "@/pages/TeamDetail";
import Players from "@/pages/Players";
import Stats from "@/pages/Stats";
import Register from "@/pages/Register";
import Auction from "@/pages/Auction";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain-overlay">
      <AuthProvider>
        <BrowserRouter>
          <ScrollManager />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsArticle />} />
            <Route path="/winners" element={<Winners />} />
            <Route path="/polls" element={<Polls />} />
            <Route path="/live" element={<Live />} />
            <Route path="/season" element={<Season />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/teams/:teamName" element={<TeamDetail />} />
            <Route path="/players" element={<Players />} />
            <Route path="/stats" element={<Stats />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auction" element={<Auction />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
          </Routes>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
